<iscustomradio
  istag="radio"
  [formControl]="formControl"
  [options]="options"
  [usecheckmarks]="usecheckmarks"
  [selectedclass]="selectedclass"
></iscustomradio>
